import { useEffect, useState } from 'react';
import accountApis from '../../../../../services/accountApis';
import { AxiosResponse } from 'axios';
import { IThemeCheckIn } from '../types';

const useGetThemeCheckIn = (shopId: string) => {
  const [data, setData] = useState<IThemeCheckIn[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IThemeCheckIn[] }> = await accountApis.getThemeCheckIn(shopId);
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching theme check-in data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (shopId) {
      fetchData();
    }
  }, [shopId]);

  return { data, loading, refetch: fetchData };
};

export default useGetThemeCheckIn;
